import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';

import 'ggApp/utils/tracking';

import { initDatadog, initDatadogRum } from 'datadog';
import { initWebviewAuthListeners } from 'ggApp/modules/inwebview_api/auth-listeners';
import WithUserDevice from 'ggApp/shared/components/viewport/withUserDevice';
import AppRoutes from 'ggApp/routes';
import { lightTheme } from 'ggApp/shared/themes';
import { ThemeProvider } from 'ggApp/shared/components/ThemeContext';
import { CartContextProvider } from 'ggApp/shared/components/CartSummary/Context';
import { OrderController } from 'ggApp/shared/context/Order/OrderController';
import { InternalToolsContextProvider } from 'ggApp/shared/context/internalTools/context';
import { FeatureFlagProvider } from 'ggApp/modules/featureFlag';
import { LanguageProvider } from 'ggApp/shared/context/language';
import { MODULE_NAME as TRANSLATOR_MODULE_NAME } from 'ggApp/modules/translator/constants';
import { TranslatorProvider } from 'ggApp/modules/translator/components/TranslatorContext';
import { DashboardAuthProvider } from 'ggApp/shared/components/NewDashboard/DashboardAuthProvider';

// eslint-disable-next-line import/no-unresolved
import de from 'ggApp/modules/translator/keys/de.json';
// eslint-disable-next-line import/no-unresolved
import nl from 'ggApp/modules/translator/keys/nl.json';
// eslint-disable-next-line import/no-unresolved
import en from 'ggApp/modules/translator/keys/en.json';
// eslint-disable-next-line import/no-unresolved
import es from 'ggApp/modules/translator/keys/es.json';

import createApolloClient from 'graphql-client';
import CookiesManager, { CookiesManagerContext } from 'ggApp/utils/CookiesManager';
import { setDeviceIdCookie } from 'ggApp/utils/DeviceIdCookie';
import { initAnalytics } from '@devsbb/analytics-client';
import loadConfiguration from 'ggApp/utils/configuration/configuration';
import configureStore from './configureStore';

const { SEGMENT_WRITE_KEY } = loadConfiguration();

initDatadog();
initDatadogRum();
initWebviewAuthListeners();
setDeviceIdCookie();
const loadAnalytics = async () => {
    await initAnalytics({
        segmentWriteKey: SEGMENT_WRITE_KEY,
        app: { name: 'frontshop' },
    }).catch(() => console.warn('Analytics failed to load.'));
};
loadAnalytics();

const initialState = { [TRANSLATOR_MODULE_NAME]: { keys: { de, nl, en, es } } };
const store = configureStore(initialState);
const cookiesManager = new CookiesManager();
const apolloClient = createApolloClient(cookiesManager);

window.globalStore = store;

ReactDOM.render(
    <Provider store={store}>
        <CookiesManagerContext.Provider value={cookiesManager}>
            <ApolloProvider client={apolloClient}>
                <WithUserDevice>
                    <CartContextProvider>
                        <OrderController>
                            <ThemeProvider theme={lightTheme}>
                                <LanguageProvider>
                                    <TranslatorProvider>
                                        <InternalToolsContextProvider>
                                            <FeatureFlagProvider>
                                                <DashboardAuthProvider>
                                                    <AppRoutes />
                                                </DashboardAuthProvider>
                                            </FeatureFlagProvider>
                                        </InternalToolsContextProvider>
                                    </TranslatorProvider>
                                </LanguageProvider>
                            </ThemeProvider>
                        </OrderController>
                    </CartContextProvider>
                </WithUserDevice>
            </ApolloProvider>
        </CookiesManagerContext.Provider>
    </Provider>,
    document.getElementById('groverApp'),
);
